<template>
    <vPerformancePersonConfigComponent :postList="postList" v-if="flag"></vPerformancePersonConfigComponent>
</template>
<script>
import vPerformancePersonConfigComponent from '../../listComponent/basicdata/performance/performancePersonConfigComponent.vue';
export default {
    name: 'performance_person_config',
    components: {
        vPerformancePersonConfigComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>